<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between margin-bottom-sm list-title">
            <b> 提醒记录 共{{ total }}条</b>
            <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
            >返回
            </el-button
            >
        </div>
        <el-radio-group class="margin-bottom-sm" v-model="type" @change="searchList">
            <el-radio-button :label="1">会员提醒</el-radio-button>
            <el-radio-button :label="2">管理员提醒</el-radio-button>
        </el-radio-group>
        <el-skeleton v-if="loading" :rows="10"/>
        <empty v-if="noData" :type="0"/>
        <div v-if="list.length>0" class="list-box">
            <div
                v-for="item in list"
                :key="item.id"
                class="item-box margin-bottom-sm">
                <h3>{{ item.message }}</h3>
                <div class="flex align-center justify-between item-info">
                    <div>
                        <p>
                            发布时间：{{ item.create_time }}
                            <span class="padding-left">
                                接收送人：
                                <i>{{ item.name }}-{{item.phone}}</i>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex align-center justify-between" v-if="list.length > 0">
            <span>共{{ total }}条数据</span>
            <el-pagination
                @current-change="getList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>


    </div>
</template>

<script>
import {getAutoSendSmsLog} from "@/api/organiz";
import {zhDate} from "@/utils/utils";

export default {
    name: "list",
    data() {
        return {
            list: [],
            type:1,
            total:0,
            page:1,
            limit:10,
            noData: false,
            loading: true,
        }
    },
    created() {
        this.$emit('setIndex', [1, 2], '提醒记录')
        this.getList()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        searchList() {
            this.page = 1
            this.getList()
        },
        //  获取发送记录
        async getList() {
            this.list = []
            this.loading = true
            let _list = await getAutoSendSmsLog(this.type,this.page,this.limit)
            if (_list.status === 0) {
                this.list = []
                this.noData = true
                this.loading = false
            } else {
                this.loading = false, this.noData = false, this.list = _list.data.data, this.total = _list.data.total
                if (_list.data.total === 0) {
                    this.list = []
                    this.noData = true
                    this.loading = false
                }
            }
        }
    },
    filters: {
        timer(val) {
            return zhDate(val)
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background: #fff;
    border-radius: 10px;

    .list-title {
        b {
            font-size: 26px;
            line-height: 34px;
        }

        .add-btn {
            display: block;
            width: 200px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #fff;
        }
    }

    .item-box {
        border-radius: 10px;
        border: solid 1px #dae0e6;

        &:hover {
            background-color: #f3f7fb;
        }

        h3 {
            font-size: 18px;
            line-height: 34px;
            padding: 5px 10px;
            color: #333333;
            font-weight: normal;
            border-bottom: 1px solid #dae0e6;
        }

        .item-info {
            padding: 15px 20px;

            p {
                line-height: 24px;
                font-size: 14px;
                color: #999999;

                i {
                    color: #ffb400;
                }
            }
        }

        .right-btn {
            .have-color {
                background: #0a2240;
                border: 0;
            }
        }
    }
}
</style>